<div class="modal-confirm--wrapper">
  <div class="modal-confirm--content">
    <div class="modal-confirm--content--title">
      <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold nx-margin-bottom-3m">
        {{ data.title | translate }}
      </h3>
    </div>
    <div class="modal-confirm--content">
      <nx-message context="success">
        <div class="modal-confirm--content--text" [innerHTML]="data.text | translate"></div>
      </nx-message>
    </div>
  </div>
</div>
